<template>
  <div class="backimg">
    <div class="search-content" style="width:100%;margin: 0 auto;">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="200"><strong>待确认</strong><span class="badge"
                                                            v-if="statusnumber200>0">{{statusnumber200}}</span>
        </el-menu-item>
        <!--<el-menu-item index="300">待加工</el-menu-item>-->
        <!--<el-menu-item index="350">待发货</el-menu-item>-->
        <!--<el-menu-item index="500">已发货</el-menu-item>-->
        <el-menu-item index="655" v-if="usereturnflow">退货待确认<span class="badge" v-if="statusnumber655>0">{{statusnumber655}}</span>
        </el-menu-item>
        <!--<el-menu-item index="700" v-if="usereturnflow">待退款</el-menu-item>-->
        <!--<el-menu-item index="750" v-if="usereturnflow">退款完成</el-menu-item>-->
        <!--<el-menu-item index="100">待支付</el-menu-item>-->
        <!--<el-menu-item index="150">已支付待选货</el-menu-item>-->
        <!--<el-menu-item index="storagebadwaitbuy">待采购<span class="badge" v-if="statusnumberbadbuy>0">{{statusnumberbadbuy}}</span></el-menu-item>-->
        <el-menu-item index="allocation" v-if="showdiaobo">调拨<span class="badge" v-if="statusnumberdiaobo>0">{{statusnumberdiaobo}}</span></el-menu-item>
        <el-menu-item index="storageframe">库存</el-menu-item>
        <!--<el-menu-item index="workload">工作量</el-menu-item>-->
        <el-menu-item index="all">全部订单</el-menu-item>
      </el-menu>
      <div class="line"></div>
    </div>
    <el-main>
      <comment :is="currentcomponent" :canMultySelect="canMultySelect" :roletype="'order'" :mystatus="status"
               v-if="visible" @bindTip="bindTip"></comment>
    </el-main>
  </div>

</template>

<script>
  import StorageFrame from '../warehouse/StorageFrame'
  import Workload from './Workload'
  import CstagreementList from './CstagreementList';
  import {countlist} from '@/api/set/csagreement';
  import {simulationLogin, checkModuleRight, getModuleRight} from '@/api/login'
  import AllocationListNew from '../../warehouse/AllocationListNew';
  import StorageBadWaitBuy from '../../warehouse/StorageBadWaitBuy';

  export default {
    data() {
      return {
        activeIndex: '200',
        currentcomponent: 'CstagreementList',
        visible: true,
        status: '200',
        statuseslist: "200;655;",
        statusnumber200: 0,
        statusnumber655: 0,
        statusnumberdiaobo:0,
        statusnumberbadbuy:0,
        showdiaobo: false,
        usereturnflow: false,
        canMultySelect: true
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        this.status = key
        this.visible = false
        if (key == "allocation") {
          this.currentcomponent = 'AllocationListNew';
        } else if (key == "storageframe") {
          this.currentcomponent = 'StorageFrame';
        } else if (key == "workload") {
          this.currentcomponent = 'workload';
        } else if (key == "storagebadwaitbuy"){
          this.currentcomponent = 'StorageBadWaitBuy'
        } else {
          this.currentcomponent = 'CstagreementList'
        }
        this.$nextTick(() => {
          this.visible = true
        })
      },
      bindTip() {
        this.statusnumber200 = 0
        this.statusnumber655 = 0
        countlist({statuseslist: this.statuseslist,roletype:'order'}).then(response => {
          response.data.obj.forEach(item => {
            if (item.status == 200) {
              this.statusnumber200 = item.number
            } else if (item.status == 655) {
              this.statusnumber655 = item.number
            } else if(item.status==901){//调拨
              this.statusnumberdiaobo=item.number
            }else if(item.status==904){//坏件 待采购
              this.statusnumberbadbuy=item.number
            }
          })
        })
      }

    },
    mounted() {
      getModuleRight().then(reponse => {
        var rightlist = ';' + reponse.data.right + ';';
        this.showdiaobo = rightlist.indexOf(';storemultip;') > -1;//多仓库关联
        this.bindTip();
      });
      //退货功能
      checkModuleRight({name: 'usereturnflow'}).then(reponse => {
        this.usereturnflow = reponse.data.code == 0;
      });
    },
    components: {
      CstagreementList,
      StorageFrame,
      AllocationListNew,
      StorageBadWaitBuy,
      Workload
    }

  }


</script>

<style scoped>
  .el-main {
    padding: 0px;
    /*height: calc(100vh - 97px);*/
    width: 100%;
    margin: 0 auto;
    background-color: white;
    overflow: auto;
  }

  .el-menu-item {
    height: 48px !important;
    line-height: 48px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/Order.vue